import { z } from 'zod'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { materialObject } from '../material/materialObject'

export const materialRequestItemObject = z.object({
  id: z.string().uuid(),
  materialRequestId: z.string().uuid(),
  materialId: materialObject.shape.id,
  requestedQuantity: z.number().int().nonnegative(),
  unitMeasure: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  material: materialObject.nullish(),
})

export const materialRequestObject = z.object({
  id: z.string().uuid(),
  citizenId: citizenObject.shape.id,
  requestDate: dateOrIsoString(),
  protocolId: z.string().uuid().nullish(),
  protocolCode: z.number().int().positive().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  citizen: citizenObject.nullish(),
  items: z.array(materialRequestItemObject).nullish(),
})

export type MaterialRequestItemType = z.infer<typeof materialRequestItemObject>
export type MaterialRequestType = z.infer<typeof materialRequestObject>

export const propertyMap = {
  id: sql`material_request.id`,
  citizenId: sql`material_request.citizen_id`,
  requestDate: sql`material_request.request_date`,
  protocolId: sql`protocol.id`,
  protocolCode: sql`protocol.code`,
  createdAt: sql`material_request.created_at`,
  updatedAt: sql`material_request.updated_at`,
  deletedAt: sql`material_request.deleted_at`,
}

export const itemPropertyMap = {
  id: sql`material_request_item.id`,
  materialRequestId: sql`material_request_item.material_request_id`,
  materialId: sql`material_request_item.material_id`,
  requestedQuantity: sql`material_request_item.requested_quantity`,
  unitMeasure: sql`material_request_item.unit_measure`,
  createdAt: sql`material_request_item.created_at`,
  updatedAt: sql`material_request_item.updated_at`,
  deletedAt: sql`material_request_item.deleted_at`,
}
